// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Types__Time = require("../../../reason/common/types/Types__Time.bs.js");
let Form__Helpers = require("../../../reason/common/Form/Form__Helpers.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");

function decodeTime(time) {
  let match = Stdlib_Option.map(time, Types__Time.decode);
  if (match !== undefined && match.TAG === "Ok") {
    return Primitive_option.some(match._0);
  }
}

function toValidationResult(valid) {
  if (valid !== undefined) {
    if (typeof valid === "object") {
      if (valid.NAME === "Error") {
        return {
          TAG: "Error",
          _0: valid.VAL
        };
      } else {
        return {
          TAG: "Ok",
          _0: "NoValue"
        };
      }
    } else if (valid === "Valid") {
      return {
        TAG: "Ok",
        _0: "Valid"
      };
    } else {
      return {
        TAG: "Ok",
        _0: "NoValue"
      };
    }
  } else {
    return {
      TAG: "Ok",
      _0: "NoValue"
    };
  }
}

function useFormControl(update, initialTouched, initialValue, valid) {
  let match = React.useState(() => initialValue);
  let setValue = match[1];
  let value = match[0];
  let match$1 = React.useState(() => initialTouched);
  let setTouched = match$1[1];
  let touched = match$1[0];
  let match$2 = React.useState(() => false);
  let setFocused = match$2[1];
  let match$3 = React.useState(() => valid === "Valid");
  let setHasBeenValid = match$3[1];
  let hasBeenValid = match$3[0];
  React.useEffect(() => {
    if (!hasBeenValid && valid === "Valid") {
      setHasBeenValid(param => true);
    }
  }, [valid !== undefined ? (
        typeof valid === "object" ? "Error" : "Valid"
      ) : undefined]);
  let tmp;
  let exit = 0;
  if (hasBeenValid || touched) {
    exit = 1;
  } else {
    tmp = undefined;
  }
  if (exit === 1) {
    tmp = valid !== undefined ? (
        typeof valid === "object" ? "error" : "ok"
      ) : undefined;
  }
  return {
    value: value,
    valueAsString: value !== undefined ? String(Primitive_option.valFromOption(value)) : "",
    onBlur: () => {
      if (!touched) {
        setTouched(param => true);
        update(value);
      }
      setFocused(param => false);
    },
    onFocus: () => setFocused(param => true),
    onChange: value => {
      setValue(param => value);
      update(value);
    },
    focused: match$2[0],
    valid: hasBeenValid || touched ? valid : undefined,
    status: tmp
  };
}

let noneIfEmpty = Form__Helpers.noneIfEmpty;

let FieldError;

exports.noneIfEmpty = noneIfEmpty;
exports.decodeTime = decodeTime;
exports.FieldError = FieldError;
exports.toValidationResult = toValidationResult;
exports.useFormControl = useFormControl;
/* react Not a pure module */
